<template>
  <div class="container registercontainer">
    <div class="row">
      <div class="col-12 col-sm-4">
        <div class="card registercard">
          <div class="card-body">
            <span class="badge badge-warning">{{ content.kindName }}</span>
            <span class="badge badge-danger"
              >學習時數: {{ content.isStudyHour }}</span
            >

            <h1 class="card-title">{{ content.title }}</h1>
          </div>
          <div class="card-body">
            <ul class="list-unstyled register_classinfo">
              <li>
                <span class="title">時間</span>
                {{ content.classTime }}
              </li>
              <li>
                <span class="title">地點</span>
                {{ content.place }}
              </li>
              <li>
                <span class="title">主辦單位</span>
                {{ content.mainOrganizer }}
              </li>
            </ul>
          </div>
          <div class="back">
            <router-link :to="'/c-' + content.code"
              ><i class="far fa-chevron-left"></i>返回詳情頁</router-link
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-8">
        <div class="card register_form">
          <h2>線上報名</h2>
          <div class="card-body">
            <form method="post" enctype="multipart/form-data" v-if="isForm">
              <div class="form-group row">
                <label for="name" class="col-sm-3 col-form-label">*姓名</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="name"
                    id="name"
                    v-model.trim="$v.forms.name.$model"
                    :class="{ 'is-invalid': $v.forms.name.$error }"
                    maxlength="100"
                  />
                  <div class="invalid-feedback" v-if="!$v.forms.name.required">
                    此欄位為必填
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="idnumber" class="col-sm-3 col-form-label"
                  >*身分證字號</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="idnumber"
                    id="idnumber"
                    v-model.trim="$v.forms.idnumber.$model"
                    :class="{ 'is-invalid': $v.forms.idnumber.$error }"
                    maxlength="10"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.forms.idnumber.required"
                  >
                    此欄位為必填
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-3 col-form-label">*性別</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="sex"
                        type="radio"
                        value="0"
                        id="sex-0"
                        v-model="forms.sex"
                      />
                      <label class="form-check-label" for="sex-0">女</label>
                    </div>

                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="sex"
                        type="radio"
                        value="1"
                        id="sex-1"
                        v-model="forms.sex"
                      />
                      <label class="form-check-label" for="sex-1">男</label>
                    </div>
                  </div>
                </div>
              </div>


              <div class="form-group row">
                <label for="serviceunit" class="col-sm-3 col-form-label"
                  >*服務單位</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="serviceunit"
                    id="serviceunit"
                    v-model.trim="$v.forms.serviceunit.$model"
                    :class="{ 'is-invalid': $v.forms.serviceunit.$error }"
                    maxlength="50"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.forms.serviceunit.required"
                  >
                    此欄位為必填
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="department" class="col-sm-3 col-form-label"
                  >*部門</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="department"
                    id="department"
                    v-model.trim="forms.department"
                    :class="{ 'is-invalid': $v.forms.department.$error }"
                    maxlength="50"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.forms.department.required"
                  >
                    此欄位為必填
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="jobtitle" class="col-sm-3 col-form-label"
                  >*職稱</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="jobtitle"
                    id="jobtitle"
                    v-model.trim="$v.forms.jobtitle.$model"
                    :class="{ 'is-invalid': $v.forms.jobtitle.$error }"
                    maxlength="50"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.forms.jobtitle.required"
                  >
                    此欄位為必填
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="tel" class="col-sm-3 col-form-label"
                  >連絡電話</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="tel"
                    id="tel"
                    v-model.trim="forms.tel"
                    maxlength="50"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="phone" class="col-sm-3 col-form-label">*手機</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="phone"
                    id="phone"
                    v-model.trim="$v.forms.phone.$model"
                    :class="{ 'is-invalid': $v.forms.phone.$error }"
                    maxlength="50"
                  />
                  <div class="invalid-feedback" v-if="!$v.forms.phone.required">
                    此欄位為必填
                  </div>
                  <div class="invalid-feedback" v-if="!$v.forms.phone.numeric">
                    此欄位只能輸入數字
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="zip" class="col-sm-3 col-form-label"
                  >郵遞區號</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="zip"
                    id="zip"
                    v-model.trim="$v.forms.zip.$model"
                    :class="{ 'is-invalid': $v.forms.zip.$error }"
                    maxlength="10"
                  />
                  <div class="invalid-feedback" v-if="!$v.forms.zip.numeric">
                    此欄位只能輸入數字
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="address" class="col-sm-3 col-form-label"
                  >聯絡地址</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    id="address"
                    v-model.trim="forms.address"
                    maxlength="100"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="email" class="col-sm-3 col-form-label"
                  >*電子信箱</label
                >
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    id="email"
                    v-model.trim="$v.forms.email.$model"
                    :class="{ 'is-invalid': $v.forms.email.$error }"
                    maxlength="50"
                  />
                  <div class="invalid-feedback" v-if="!$v.forms.email.required">
                    此欄位為必填
                  </div>
                  <div class="invalid-feedback" v-if="!$v.forms.email.email">
                    請輸入正確的電子郵件
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-3 col-form-label">*公務人員學習時數</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="isstudy"
                        type="radio"
                        value="1"
                        id="isstudy-1"
                        v-model="forms.isstudy"
                      />
                      <label class="form-check-label" for="isstudy-1">是</label>
                    </div>
                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="isstudy"
                        type="radio"
                        value="0"
                        id="isstudy-0"
                        v-model="forms.isstudy"
                      />
                      <label class="form-check-label" for="isstudy-0">否</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-3 col-form-label">*膳食(葷素)</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="food"
                        type="radio"
                        value="0"
                        id="food-0"
                        v-model="forms.food"
                      />
                      <label class="form-check-label" for="food-0">葷</label>
                    </div>

                    <div class="form-check form-check-info">
                      <input
                        class="form-check-input radio-primary"
                        name="food"
                        type="radio"
                        value="1"
                        id="food-1"
                        v-model="forms.food"
                      />
                      <label class="form-check-label" for="food-1">素</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-3 col-form-label"></label>
                <div class="col-sm-9">
                  <button
                    type="button"
                    class="btn btn-lg btn-registration btn-info btn-block"
                    @click="clickSubmit"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    線上報名
                  </button>
                </div>
              </div>
            </form>
            <div class="text-center" v-if="!isForm">
              <p class="lead">報名完成。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiContent, apiSignup } from '@/api/index'
import { required, email, numeric } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      content: {},
      forms: {
        parentcode: this.$route.params.code,
        name: '',
        idnumber: '',
        serviceunit: '',
        department: '',
        jobtitle: '',
        tel: '',
        phone: '',
        zip: '',
        address: '',
        email: '',
        isstudy: 1,
        food: 0,
        sex: 0
      },
      submitStatus: null,
      isForm: true,
    }
  },
  validations: {
    forms: {
      name: {
        required,
      },
      idnumber: {
        required,
      },
      serviceunit: {
        required,
      },
      department: {
        required,
      },
      jobtitle: {
        required,
      },
      phone: {
        required,
        numeric,
      },
      zip: {
        numeric,
      },
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    async getContent() {
      let loader = this.$loading.show()
      await apiContent(this.$route.params.code)
        .catch(error => {
          if (error.response) {
            this.goBack()
          }
        })
        .then(response => {
          if (response) {
            this.content = response.data
            if (this.content.isOpen === 0) this.goBack()
          }
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
    },
    clickSubmit() {
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.Send()
      }
    },
    async Send() {
      let loader = this.$loading.show()
      this.forms.isstudy = parseInt(this.forms.isstudy)
      this.forms.food = parseInt(this.forms.food)
      this.forms.sex = parseInt(this.forms.sex)
      await apiSignup(this.forms)
        .then(response => {
          this.submitStatus = null
          this.isForm = false
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
        .catch(err => {
          this.$swal('', err.response.data.detail, 'error')
          this.submitStatus = null
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
    },
    goBack() {
      this.$router.push('./')
    },
  },
  mounted() {
    this.getContent()
  },
}
</script>
